// @flow
import urijs from 'urijs';
import { includes } from 'lodash';
import { appQueryParameters } from '@clubmed/utils';
const { locale } = appQueryParameters;

const ALLOWED_QUERY_PARAMETERS = [locale];

function isAllowedQueryParameter(queryParameter) {
  return includes(ALLOWED_QUERY_PARAMETERS, queryParameter);
}

function getCanonicalQueryParameters(queryParams) {
  return Object.keys(queryParams)
    .filter(isAllowedQueryParameter)
    .reduce((filteredQueryParams, queryParamName) => {
      return { ...filteredQueryParams, [queryParamName]: queryParams[queryParamName] };
    }, {});
}

function getCanonicalUrl(url: string): string {
  const uri = urijs(url);
  const uriQueryParameters = urijs.parseQuery(uri.query());
  const segments = uri.segmentCoded();
  return uri
    .segment(segments)
    .query(getCanonicalQueryParameters(uriQueryParameters))
    .hash('')
    .toString();
}

export default {
  getCanonicalUrl,
};
